import { Dtos, SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { accountCompaniesQueryKey } from "./account.keys";

export const useFetchAccountCompanies = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: accountCompaniesQueryKey(accountId),
		queryFn: () => get<Dtos.Company.Get.Response[]>(`/v2/surety/accounts/${accountId}/companies`),
	});

	return {
		companies: data,
		companiesError: error,
		companiesIsLoading: isLoading,
		refetchAccountCompanies: refetch,
	};
};
